export default "__VITE_ASSET__ysv9urDX__"